export function isMatchPath(key: string, path: string) {
  const cleanKey = key.replace(/^[a-z]{2}\//, '').replace(/\/$/, '')
  const cleanPath = path.replace(/^[a-z]{2}\//, '').replace(/\/$/, '')
  return cleanKey === cleanPath
}
